// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"pvbUSAylfsgtMLfkMzyW_","spaceLeft":"_166KBa0OohTDK4NRIYBUdn","spaceBoth":"_3XaWpImULW3Q9FtJUqzi0R","spaceRight":"_3XR8fAcZl_X1f9E4pluR7j","heading":"dEAjTHoWQiKFLbYRaz5ek","actions":"_2oZI0ShAV8a_kulROz3tbH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisOfferCancelModal.scss
// module id = 1268
// module chunks = 0